import React, { useMemo, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useStateRef from 'react-usestateref'
import useInterval from '@use-it/interval'
import { createCable } from '@anycable/web'
// import { LongPollingTransport } from '@anycable/long-polling'

import { setWindowConnectionState } from '../websocket_connection.jsx'

export default function AnycableConnection({ onMessageCompleted, channels, ...props}) {

  const config = useSelector(state => state.websocket?.anycable)

  if(!config || !config.enabled) {
    console.warn("[Anycable] disabled")
    return <></>
  }
  
  const [renderedConnectionState, setConnectionState, connectionState] = useStateRef("connecting")


  const [connectionRetries, setConnectionRetries] = useState(0)

  //const connectionInitialized = (data) => {
  //  console.debug("[Anycable] connectionInitialized", data)
  //  setConnectionState("initialized")
  //  setWindowConnectionState("anycable", false)
  //}
  //const connectionConnecting = (data) => {
  //  console.debug("[Anycable] connectionConnecting", data)
  //  setConnectionState("connecting")
  //  setWindowConnectionState("anycable", false)
  //}
  const connectionConnected = (data) => {
    console.debug("[Anycable] connectionConnected", data)
    setConnectionState("connected")
    setWindowConnectionState("anycable", true)
  }
  //const connectionUnavailable = (data) => {
  //  console.debug("[Anycable] connectionUnavailable", data)
  //  setConnectionState("unavailable")
  //  setWindowConnectionState("anycable", false)
  //}
  //const connectionFailed = (data) => {
  //  console.debug("[Anycable] connectionFailed", data)
  //  setConnectionState("failed")
  //  setWindowConnectionState("anycable", false)
  //}
  const connectionDisconnected = (data) => {
    console.debug("[Anycable] connectionDisconnected", data)
    setConnectionState("disconnected")
    setWindowConnectionState("anycable", false)
  }
  const connectionUnloading = (data) => {
    console.debug("[Anycable] connectionUnloading", data)
    setConnectionState("unloading")
    setWindowConnectionState("anycable", false)
  }

  useEffect(() => {

    console.debug({config})

    // Long Polling is part of anacable PRO
    //const transport = new LongPollingTransport(window.location.hostname == "localhost" ? 'http://localhost:8080/cable/lp' : ('https://' + window.location.hostname + '/cable/lp'))
    //const client = createCable({transport})

    const client = createCable(window.location.hostname == "localhost" ? 'ws://localhost:8080/cable' : ('wss://' + window.location.hostname + '/cable'), {
     protocol: 'actioncable-v1-ext-json'
    })
    

    client.on('connect', connectionConnected)
    client.on('disconnect', connectionDisconnected)
    client.on('close', connectionUnloading)

    let subscriptions = []

    config.channels.map(channelConfig => {
      
      console.log("Subscribing to ", channelConfig)

      const subscription = client.subscribeTo(channelConfig?.channel, channelConfig?.params) // , { roomId: '42' }
      subscription.on('message', msg => {
        console.log("via", channelConfig?.channel, msg)
        onMessageCompleted("anycable", msg.id, { type: msg.type, payload: msg.payload })
      })

      subscriptions.push(subscription)
      // const subscription = client.subscribe(channelName).bind_global((eventName, message) => {
      //   if(eventName.startsWith("CABLE_")) {
      //     console.warn("[Anycable]", eventName)
      //     console.warn("[Anycable]", message)
      //     if (message.data) {
      //       //const rawData = decode(message.binaryBody)
      //       console.debug('[Anycable] got message in channel ' + channelName + ' with body ', message.data);
      //       //const data = JSON.parse(message.data)
      //       try {
      //         onMessageCompleted("anycable", message.id, { type: eventName, payload: message.data })
      //       } catch(ex) {
      //         console.error(ex)
      //       }
      //     } else {
      //       console.error('[Anycable] got empty message');
      //     }
      //   } else {
      //     console.log('[Anycable] SKIPPING MESSAGE');
      //   }
      // })
    })

    return () => {
      subscriptions.map(subscription => {
        console.log(subscription)
        subscription.disconnect()
      })
      channel.disconnect()
      console.debug("Unloading anycable");
    }
  }, [config, channels])




  if(false) {
    return <div style={{fontSize: "0.6rem", padding: "10px", backgroundColor: "white"}}>
      <pre>{JSON.stringify(parseJwt(config.token), null, 3)}</pre>
      <div className="btn btn-danger btn-sm" onClick={() => { 
          //client.publish({ destination: '/exchange/public', body: encode('Hello world') }); 
          client.publish({ destination: '/queue/public', body: encode('Hello world') }); 

        } }>
        Publish
      </div>
    </div>
  }


  switch(connectionState?.current) {
    case "initialized":
      return <div className="network-status network-status-warning">
        <i className="fa fa-spinner fa-spin"></i>{" "}
        Initializing via Anycable... Try #{connectionRetries}
      </div>
    case "connecting":
      return <div className="network-status network-status-warning">
        <i className="fa fa-spinner fa-spin"></i>{" "}
        Connecting via Anycable... Try #{connectionRetries}
      </div>
    case "connected":
      return <div className="network-status network-status-success">
        <i className="fa fa-check"></i>{" "}
        Anycable connected
      </div>
    case "unavailable":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Anycable unavailable
      </div>

    case "failed":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Anycable connection failed
      </div>
    case "disconnected":
      return <div className="network-status network-status-danger">
        <i className="fa fa-times"></i>{" "}
        Anycable disconnected
      </div>
    case "unloading":
      return <></>
    default:
      return <div className="network-status network-status-danger">Unknown connection state for  Anycable</div>
  }

  return <></>
}
